import HeadSectionCampaignComponent from "./HeadSectionCampaign";

export default HeadSectionCampaignComponent